var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-mask d-flex flex-column align-items-center justify-content-center"},[_c('div',{staticClass:"progress",staticStyle:{"width":"80%"}},[_c('div',{staticClass:"progress-bar",style:({
        width: ((_vm.getDataLoadingProgress()) + "%"),
        'background-color': '#88b3ff'
      }),attrs:{"role":"progressbar","aria-valuenow":"50","aria-valuemin":"0","aria-valuemax":"100"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }